import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="careers-filter"
// Shows only the job postings of the selected department, without a reload.
export default class extends Controller {
  static targets = ["chip", "group"];

  select({ currentTarget, params }) {
    const department = String(params.department ?? "");

    this.chipTargets.forEach((chip) => {
      chip.setAttribute("aria-pressed", String(chip === currentTarget));
    });

    this.groupTargets.forEach((group) => {
      group.hidden = department !== "" && group.dataset.department !== department;
    });
  }
}
